"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeakerSeparationResponseModelStatus = void 0;
exports.SpeakerSeparationResponseModelStatus = {
    NotStarted: "not_started",
    Pending: "pending",
    Completed: "completed",
    Failed: "failed",
};
